export interface CriteriaFunction {
  supportsValue(value: any): boolean;
  getFilter<T>(key: string, value: any): (t: T) => boolean;
}
